import easyfyAxios from '@shared/easyfy.axios';
import { sleep } from '@shared/easyfy.utils';

export const LogOut = async (): Promise<any> => {
  const result = await easyfyAxios.get('/api/logout');
  await sleep(200); //For logged out events to have time to be sent
  return result;
};
